import { render, staticRenderFns } from "./rsIndex.vue?vue&type=template&id=143ff6d0&"
import script from "./rsIndex.vue?vue&type=script&lang=js&"
export * from "./rsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rsIndex.vue"
export default component.exports